import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  tahun: number;

  constructor() { }

  ngOnInit() {
    let tgl = new Date();
    this.tahun = tgl.getFullYear();
  }

}
